import { Directions } from "@mui/icons-material";
import instance from "../../../api/interceptor";
import { API_PATH } from "../../../constant/apiPath";
import { ACTION_TYPE } from "../constants/actionType";
import { LOCAL_STORAGE_USER_KEY } from "../../../Config";

// TODO: getShipments is getting hit twice. Need to investigate why.
export const getShipments =
  (count, search, advancesearch, showstatus, isSearch, signal, orgCode) =>
  async (dispatch) => {
    console.log("selectedOrgCodes getShipments", orgCode);
    const storedUser = localStorage.getItem(LOCAL_STORAGE_USER_KEY);
    const userData = JSON.parse(storedUser) || {};
    const CompanyCode = userData.companycode || "";
    const defaultPayload = {
      ShipmentId: "",
      OrgCode: "",
      EmailId: "",
      OriginPortCode: "",
      DestinationPortCode: "",
      OriginPortName: "",
      DestinationPortName: "",
      CNPJ: "",
      Ship: "",
      PONumber: "",
      ShipperName: "",
      ConsigneeName: "",
      // Status:
      //   advancesearch?.activeP ||
      //   advancesearch?.activeL ||
      //   advancesearch?.activeAr
      //     ? advancesearch?.status || ""
      //     : showstatus ?? "",
      Status:
        advancesearch?.activeP ||
        advancesearch?.activeL ||
        advancesearch?.activeAr
          ? advancesearch?.status || ""
          : showstatus || "",

      SortColumnName: advancesearch?.sort ?? "",
      SortDirection: advancesearch?.order ?? "",
      CurrentPage: count,
      PageSize: 20,
      TransportMode:
        advancesearch?.activeA ||
        advancesearch?.activeS ||
        advancesearch?.activeR
          ? (advancesearch?.mode ?? "")
          : "",
      Direction:
        advancesearch?.activeI || advancesearch?.activeE
          ? (advancesearch?.direction ?? "")
          : "",
      SearchLoading: isSearch ?? 0,
      Waybill: "",
      SearchField: "",
    };

    let payload = { ...defaultPayload };
    if (search && search.fields && typeof search.fields === "object") {
      // map provided fields into payload where keys match payload names
      payload = { ...payload, ...search.fields, OrgCode: orgCode || "" };
    } else {
      // backward compatible single {type,value} usage
      payload = {
        ...payload,
        ShipmentId: search.type === "ShipmentId" ? search.value : "",
        OriginPortCode: search.type === "Origin" ? search.value : "",
        DestinationPortCode: search.type === "Destination" ? search.value : "",
        OriginPortName: search.type === "Origin Port" ? search.value : "",
        DestinationPortName:
          search.type === "Destination Port" ? search.value : "",
        CNPJ: search.type === "CNPJ" ? search.value : "",
        Ship: search.type === "Ship" ? search.value : "",
        PONumber: search.type === "PO Number" ? search.value : "",
        ShipperName: search.type === "ShipperName" ? search.value : "",
        ConsigneeName: search.type === "ConsigneeName" ? search.value : "",
        Waybill: search.type === "Waybill" ? search.value : "",
        SearchField:
          search.type === "Ref" || search.type === "ShipperReff"
            ? search.value
            : "",

        OrgCode: orgCode || "",
      };
    }

    if (!payload.CurrentPage) {
      dispatch({ type: ACTION_TYPE.SHIPMENT_LIST_REQUEST });
    } else {
      dispatch({ type: ACTION_TYPE.LOADING_MORE_SHIPMENT });
    }

    const url = `${API_PATH.GET_SHIPMENT_LIST}?CompanyCode=${CompanyCode}`;
    await instance
      .post(url, payload, { signal })
      .then((data) => {
        if (!payload.CurrentPage) {
          dispatch({
            type: ACTION_TYPE.SHIPMENT_LIST_SUCCESS,
            payload: data,
          });
        } else {
          dispatch({
            type: ACTION_TYPE.SHIPMENT_LIST_SUCCESS_PAGE,
            payload: data,
          });
        }
      })
      .catch((error) => {
        // If request was cancelled/aborted, do not treat as a failure
        if (error?.code === "ERR_CANCELED" || error?.name === "CanceledError") {
          console.log("shipment request canceled", error);
          return;
        }
        dispatch({
          type: ACTION_TYPE.SHIPMENT_LIST_FAIL,
          error: error,
        });
        console.log("shipment list action fail", error);
      });
  };
